<template>
  <div class="container-fluid mb-4 gs-header-filters">
    <b-button
        class="header-filter-btns"
        :class="selected == 'all' && currentTab == 'all' ? 'active' : ''"
        variant="theme"
        @click="activateTab('all')"
    >
        All
        <i class="fas text-primary fa-layer-group fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'deliverables' || currentTab == 'deliverables' ? 'active' : ''"
        variant="theme"
        @click="activateTab('deliverables')"
    >
        Deliverables
        <i class="fas text-primary fa-list fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'projects' || currentTab == 'projects' ? 'active' : ''"
        variant="theme"
        @click="activateTab('projects')"
    >
        Projects
        <i class="fas text-primary fa-book fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'departments' || currentTab == 'departments' ? 'active' : ''"
        variant="theme"
        @click="activateTab('departments')"
    >
        Departments
        <i class="fas text-primary fa-sitemap fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'contacts' || currentTab == 'contacts' ? 'active' : ''"
        variant="theme"
        @click="activateTab('contacts')"
    >
        Contacts
        <i class="far text-primary fa-id-badge fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'coordinators' || currentTab == 'coordinators' ? 'active' : ''"
        variant="theme"
        @click="activateTab('coordinators')"
    >
        Coordinators
        <i class="far text-primary fa-user-circle fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="selected == 'tags' || currentTab == 'tags' ? 'active' : ''"
        variant="theme"
        @click="activateTab('tags')"
    >
        Tags
        <i class="fas text-primary fa-hashtag fa-fw float-right"></i>
    </b-button>
  </div>
</template>

<script>
export default {
    props: [
        'currentTab'
    ],
    data() {
        return {
            selected: 'all'
        }
    },
    methods: {
        activateTab(activeTab) {
            this.selected = activeTab;
            this.$emit('click', activeTab);
        }
    }
}
</script>

<style>

</style>